import styled from "@emotion/styled";
import { Card } from "@lightspeed/flame/Card";

const Wrapper = styled(Card)`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    font-size: 2rem;
    font-weight: 700;
    opacity: 0.5;
  }
`;

const NoItems = () => {
  return (
    <Wrapper>
      <p>No items to display</p>
    </Wrapper>
  );
};

export default NoItems;
